export const initialRoute = '/app';

export const plansName = {
  basic: 'Basic',
  premium: 'Premium',
  professional: 'Professional',
};

export const memberRoles = {
  owner: 'OWNER',
  clinicianAdmin: 'CLINICIAN_ADMIN',
  clinicianFullClient: 'CLINICIAN_FULL_CLIENT',
  clinicianBasicBilling: 'CLINICIAN_BASIC_BILLING',
  clinicianBasic: 'CLINICIAN_BASIC',
  supervisor: 'SUPERVISOR',
  biller: 'BILLER',
  scheduler: 'SCHEDULER',
};

export const exerciseIcons = {
  'abc.png': require('../image/icons/icons/abc.png'),
  'acting-on-urges.png': require('../image/icons/icons/acting-on-urges.png'),
  'ask-say-no.png': require('../image/icons/icons/ask-say-no.png'),
  'balancing.png': require('../image/icons/icons/balancing.png'),
  'behavior-change.png': require('../image/icons/icons/behavior-change.png'),
  'being-doing.png': require('../image/icons/icons/being-doing.png'),
  'body-sensation.png': require('../image/icons/icons/body-sensation.png'),
  'challenge-myth.png': require('../image/icons/icons/challenge-myth.png'),
  'challenge.png': require('../image/icons/icons/challenge.png'),
  'change-emotion.png': require('../image/icons/icons/change-emotion.png'),
  'change-face-temp.png': require('../image/icons/icons/change-face-temp.png'),
  'check-facts.png': require('../image/icons/icons/check-facts.png'),
  'checklist.png': require('../image/icons/icons/checklist.png'),
  'crisis-skills.png': require('../image/icons/icons/crisis-skills.png'),
  'crisis.png': require('../image/icons/icons/crisis.png'),
  'dialectics.png': require('../image/icons/icons/dialectics.png'),
  'distress-after.png': require('../image/icons/icons/distress-after.png'),
  'distress-before.png': require('../image/icons/icons/distress-before.png'),
  'effective.png': require('../image/icons/icons/effective.png'),
  'emotion-analysis.png': require('../image/icons/icons/emotion-analysis.png'),
  'emotion-does.png': require('../image/icons/icons/emotion-does.png'),
  'emotion-myths.png': require('../image/icons/icons/emotion-myths.png'),
  'how-skill.png': require('../image/icons/icons/how-skill.png'),
  'icons8-bipolar_disease.png': require('../image/icons/icons/icons8-bipolar_disease.png'),
  'imagination.png': require('../image/icons/icons/imagination.png'),
  'IMPROVE-one.png': require('../image/icons/icons/IMPROVE-one.png'),
  'IMPROVE.png': require('../image/icons/icons/IMPROVE.png'),
  'intense-exercise.png': require('../image/icons/icons/intense-exercise.png'),
  'like.png': require('../image/icons/icons/like.png'),
  'loving-kindness.png': require('../image/icons/icons/loving-kindness.png'),
  'mastery.png': require('../image/icons/icons/mastery.png'),
  'meditation.png': require('../image/icons/icons/meditation.png'),
  'middle-path.png': require('../image/icons/icons/middle-path.png'),
  'mindful-one-skill.png': require('../image/icons/icons/mindful-one-skill.png'),
  'mindful-others.png': require('../image/icons/icons/mindful-others.png'),
  'mindful.png': require('../image/icons/icons/mindful.png'),
  'nonjudgmental.png': require('../image/icons/icons/nonjudgmental.png'),
  'notice.png': require('../image/icons/icons/notice.png'),
  'observe-describe-participate.png': require('../image/icons/icons/observe-describe-participate.png'),
  'observe-emotions.png': require('../image/icons/icons/observe-emotions.png'),
  'odp-bs.png': require('../image/icons/icons/odp-bs.png'),
  'opposite-action.png': require('../image/icons/icons/opposite-action.png'),
  'outcome.png': require('../image/icons/icons/outcome.png'),
  'paced-breathing.png': require('../image/icons/icons/paced-breathing.png'),
  'paired-muslcle-relax.png': require('../image/icons/icons/paired-muslcle-relax.png'),
  'participate.png': require('../image/icons/icons/participate.png'),
  'pleasant.png': require('../image/icons/icons/pleasant.png'),
  'priority.png': require('../image/icons/icons/priority.png'),
  'prosCons.png': require('../image/icons/icons/prosCons.png'),
  'punish.png': require('../image/icons/icons/punish.png'),
  'radical-acceptance-one.png': require('../image/icons/icons/radical-acceptance-one.png'),
  'radical-acceptance.png': require('../image/icons/icons/radical-acceptance.png'),
  'rating-after.png': require('../image/icons/icons/rating-after.png'),
  'rating-before.png': require('../image/icons/icons/rating-before.png'),
  'rating.png': require('../image/icons/icons/rating.png'),
  'resisting-urges.png': require('../image/icons/icons/resisting-urges.png'),
  'rethink.png': require('../image/icons/icons/rethink.png'),
  'script.png': require('../image/icons/icons/script.png'),
  'select-skill.png': require('../image/icons/icons/select-skill.png'),
  'self-respect.png': require('../image/icons/icons/self-respect.png'),
  'self-soothe.png': require('../image/icons/icons/self-soothe.png'),
  'sleep.png': require('../image/icons/icons/sleep.png'),
  'stop-behavior.png': require('../image/icons/icons/stop-behavior.png'),
  'STOP.png': require('../image/icons/icons/STOP.png'),
  'text.png': require('../image/icons/icons/text.png'),
  'TIP.png': require('../image/icons/icons/TIP.png'),
  'tracking.png': require('../image/icons/icons/tracking.png'),
  'troubleshoot.png': require('../image/icons/icons/troubleshoot.png'),
  'unpleasant.png': require('../image/icons/icons/unpleasant.png'),
  'validate.png': require('../image/icons/icons/validate.png'),
  'values-action-steps.png': require('../image/icons/icons/values-action-steps.png'),
  'vulnerability.png': require('../image/icons/icons/vulnerability.png'),
  'what-skill.png': require('../image/icons/icons/what-skill.png'),
  'wise-mind.png': require('../image/icons/icons/wise-mind.png'),
  'abstinence.png': require('../image/icons/icons/abstinence.png'),
  'adaptive-denial.png': require('../image/icons/icons/adaptive-denial.png'),
  'bridge.png': require('../image/icons/icons/bridge.png'),
  'clear-clean-mind.png': require('../image/icons/icons/clear-clean-mind.png'),
  'half-smile.png': require('../image/icons/icons/half-smile.png'),
  'mindful-current.png': require('../image/icons/icons/mindful-current.png'),
  'mindful-thoughts.png': require('../image/icons/icons/mindful-thoughts.png'),
  'reality-acceptance.png': require('../image/icons/icons/reality-acceptance.png'),
  'reality-acceptance-one.png': require('../image/icons/icons/reality-acceptance-one.png'),
  'reinforce.png': require('../image/icons/icons/reinforce.png'),
  'addiction.png': require('../image/icons/icons/addiction.png'),
  'distract.png': require('../image/icons/icons/distract.png'),
  'turning-mind.png': require('../image/icons/icons/turning-mind.png'),
  'distract-one.png': require('../image/icons/icons/distract-one.png'),
  'audio.png': require('../image/icons/icons/audio.png'),
  'willing.png': require('../image/icons/icons/willing.png'),
  'thought.png': require('../image/icons/icons/thought.png'),
  'how.png': require('../image/icons/icons/how.png'),
  'practice.png': require('../image/icons/icons/practice.png'),
  'prompting-event.png': require('../image/icons/icons/prompting-event.png'),
  'goal.png': require('../image/icons/icons/goal.png'),
  'desire.png': require('../image/icons/icons/desire.png'),
  'interpersonal.png': require('../image/icons/icons/interpersonal.png'),
  'black-white.png': require('../image/icons/icons/black-white.png'),
  'confusion.png': require('../image/icons/icons/confusion.png'),
  'exaggerate.png': require('../image/icons/icons/exaggerate.png'),
  'evidence.png': require('../image/icons/icons/evidence.png'),
  'negative-belief.png': require('../image/icons/icons/negative-belief.png'),
  'icons8-drunk-100.png': require('../image/icons/icons/icons8-drunk-100.png'),
  'all-or-nothing.png': require('../image/icons/icons/all-or-nothing.png'),
  'blaming.png': require('../image/icons/icons/blaming.png'),
  'catastrophizing.png': require('../image/icons/icons/catastrophizing.png'),
  'emotional-reasoning.png': require('../image/icons/icons/emotional-reasoning.png'),
  'fortune-telling.png': require('../image/icons/icons/fortune-telling.png'),
  'labeling.png': require('../image/icons/icons/labeling.png'),
  'magnification.png': require('../image/icons/icons/magnification.png'),
  'mind-reading.png': require('../image/icons/icons/mind-reading.png'),
  'over-generalization.png': require('../image/icons/icons/over-generalization.png'),
  'should-statements.png': require('../image/icons/icons/should-statements.png'),
  'thumbs-up.png': require('../image/icons/icons/thumbs-up.png'),
  'thumbs-down.png': require('../image/icons/icons/thumbs-down.png'),
  'long-term.png': require('../image/icons/icons/long-term.png'),
  'five-years-now.png': require('../image/icons/icons/five-years-now.png'),
  'activity-1.png': require('../image/icons/icons/activity-1.png'),
  'activity-2.png': require('../image/icons/icons/activity-2.png'),
  'running.png': require('../image/icons/icons/running.png'),
  'food.png': require('../image/icons/icons/food.png'),
  'location.png': require('../image/icons/icons/location.png'),
  'vomit.png': require('../image/icons/icons/vomit.png'),
  'prediction.png': require('../image/icons/icons/prediction.png'),
  'icons8-unamused-emoticon': require('../image/icons/icons8-unamused-emoticon.png'),
  'icons8-therapy': require('../image/icons/icons8-therapy.png'),
  'icons8-idea-light': require('../image/icons/icons8-idea-light.png'),
  'icons8-thought-bubble': require('../image/icons/icons8-thought-bubble.png'),
  'icons8-exercise': require('../image/icons/icons8-exercise.png'),
  'icons8-stop-hand-in-a-circle': require('../image/icons/icons8-stop-hand-in-a-circle.png'),
  'icons8-attendance-mark': require('../image/icons/icons8-attendance.png'),
  'icons8-charity': require('../image/icons/icons8-charity.png'),
  'icons8-hug': require('../image/icons/icons8-hug.png'),
  'icons8-music-filled': require('../image/icons/icons8-music-filled.png'),
  'icons8-development-skill': require('../image/icons/icons8-development-skill.png'),
  'icons8-direction': require('../image/icons/icons8-direction.png'),
  'icons8-solve': require('../image/icons/icons8-solve.png'),
  'icons8-positive': require('../image/icons/icons8-positive.png'),
  'icons8-guru': require('../image/icons/icons8-guru.png'),
  'icons8-advice': require('../image/icons/icons8-advice.png'),
  'icons8-low-priority': require('../image/icons/icons8-low-priority.png'),
  'icons8-transformation-skill': require('../image/icons/icons8-transformation-skill.png'),
  'icons8-test': require('../image/icons/icons8-test.png'),
  'icons8-communication': require('../image/icons/icons8-communication.png'),
  'icons8-hand-holding-bulb': require('../image/icons/icons8-hand-holding-bulb.png'),
  'icons8-self-reflection': require('../image/icons/icons8-self-reflection.png'),
  'icons8-under-pressure-male': require('../image/icons/icons8-under-pressure-male.png'),
  'icons8-friends': require('../image/icons/icons8-friends.png'),
  'icons8-yin-yang-sign': require('../image/icons/icons8-yin-yang-sign.png'),
  'icons8-green-check-mark': require('../image/icons/icons8-green-check-mark.png'),
  'icons8-wise-mind': require('../image/icons/icons8-wise-mind.png'),
  'icons8-observe': require('../image/icons/icons8-observe.png'),
  'icons8-communication-skill': require('../image/icons/icons8-communication-skill.png'),
  'icons8-open-hands-with-a-box': require('../image/icons/icons8-open-hands-with-a-box.png'),
  'icons8-happy': require('../image/icons/icons8-happy.png'),
  'icons8-brainstorm-skill': require('../image/icons/icons8-brainstorm-skill.png'),
  'icons8-mind': require('../image/icons/icons8-mind.png'),
  'icons8-bully': require('../image/icons/icons8-bully.png'),
  // Target Icons
  'icons8-angry-emoji-face': require('../image/icons/icons8-angry-emoji-face.png'),
  'icons8-bitter-facial-expression': require('../image/icons/icons8-bitter-facial-expression.png'),
  'icons8-angry-male-emoticon': require('../image/icons/icons8-angry-male-emoticon.png'),
  'icons8-sad': require('../image/icons/icons8-sad.png'),
  'icons8-scared-face': require('../image/icons/icons8-scared-face.png'),
  'icons8-embarrassed': require('../image/icons/icons8-embarrassed.png'),
  'icons8-happy-face-emoticon': require('../image/icons/icons8-happy-face-emoticon.png'),
  'icons8-conflict': require('../image/icons/icons8-conflict.png'),
  'icons8-sad-face': require('../image/icons/icons8-sad-face.png'),
  'icons8-worried-face': require('../image/icons/icons8-worried-face.png'),
  'icons8-pills': require('../image/icons/icons8-pills.png'),
  'icons8-alcohol': require('../image/icons/icons8-alcohol.png'),
  'icons8-self-destruct': require('../image/icons/icons8-self-destruct.png'),
  'icons8-suicide-by-drop-hanging': require('../image/icons/icons8-suicide-by-drop-hanging.png'),
  'icons8-drunk': require('../image/icons/icons8-drunk.png'),
  'icons8-syringe': require('../image/icons/icons8-syringe.png'),
  'icons8-gamble': require('../image/icons/icons8-gamble.png'),
  'icons8-fraud': require('../image/icons/icons8-fraud.png'),
  'icons8-pickpocket': require('../image/icons/icons8-pickpocket.png'),
  'icons8-scream': require('../image/icons/icons8-scream.png'),
  // Activities Icons
  'icons8-work': require('../image/icons/icons8-work.png'),
  'icons8-online-dating': require('../image/icons/icons8-online-dating.png'),
  'icons8-handball': require('../image/icons/icons8-handball.png'),
  'icons8-party': require('../image/icons/icons8-party.png'),
  'icons8-movie-roll': require('../image/icons/icons8-movie-roll.png'),
  'icons8-reading': require('../image/icons/icons8-reading.png'),
  'icons8-nintendo-without-card': require('../image/icons/icons8-nintendo-without-card.png'),
  'icons8-buy': require('../image/icons/icons8-buy.png'),
  'icons8-walking-silhouette': require('../image/icons/icons8-walking-silhouette.png'),
  'icons8-dining-room': require('../image/icons/icons8-dining-room.png'),
  'icons8-housekeeper': require('../image/icons/icons8-housekeeper.png'),
  'icons8-running': require('../image/icons/icons8-running.png'),
  'icons8-dog-training': require('../image/icons/icons8-dog-training.png'),
  'icons8-frisbee': require('../image/icons/icons8-frisbee.png'),
  'icons8-church': require('../image/icons/icons8-church.png'),
  'icons8-cat': require('../image/icons/icons8-cat.png'),
  'icons8-guitar': require('../image/icons/icons8-guitar.png'),
  'icons8-choir': require('../image/icons/icons8-choir.png'),
  'icons8-bowling-pins': require('../image/icons/icons8-bowling-pins.png'),

  'asleep-in-class': require('../image/icons/logs/asleep-in-class.png'),
  '8-ounces-glass-of-water-in-the-morning': require('../image/icons/logs/8-ounces-glass-of-water-in-the-morning.png'),
  'aerobic-exercises': require('../image/icons/logs/aerobic-exercises.png'),
  'air-popped-popcorn-as-evening-snack': require('../image/icons/logs/air-popped-popcorn-as-evening-snack.png'),
  alcohol: require('../image/icons/logs/alcohol.png'),
  'biting-pen': require('../image/icons/logs/biting-pen.png'),
  'checking-iphone': require('../image/icons/logs/checking-iphone.png'),
  'coffee-cup': require('../image/icons/logs/coffee-cup.png'),
  'do-something-fun-together': require('../image/icons/logs/do-something-fun-together.png'),
  'drinking-soda': require('../image/icons/logs/drinking-soda.png'),
  'drinking-tea': require('../image/icons/logs/drinking-tea.png'),
  'eating-candy': require('../image/icons/logs/eating-candy.png'),
  'eating-cookies': require('../image/icons/logs/eating-cookies.png'),
  'eating-dairy': require('../image/icons/logs/eating-dairy.png'),
  'eating-fast-food': require('../image/icons/logs/eating-fast-food.png'),
  'eating-meat': require('../image/icons/logs/eating-meat.png'),
  'eating-past-8': require('../image/icons/logs/eating-past-8.png'),
  'eating-sugar': require('../image/icons/logs/eating-sugar.png'),
  'emotional-shopping': require('../image/icons/logs/emotional-shopping.png'),
  'energy-drink': require('../image/icons/logs/energy-drink.png'),
  facebook: require('../image/icons/logs/facebook.png'),
  'fiddling-with-keys': require('../image/icons/logs/fiddling-with-keys.png'),
  'forgetting-names': require('../image/icons/logs/forgetting-names.png'),
  gambling: require('../image/icons/logs/gambling.png'),
  'gaming-in-class': require('../image/icons/logs/gaming-in-class.png'),
  'going-to-club': require('../image/icons/logs/going-to-club.png'),
  'green-tea': require('../image/icons/logs/green-tea.png'),
  'healthy-oil': require('../image/icons/logs/healthy-oil.png'),
  'job-interview-skills': require('../image/icons/logs/job-interview-skills.png'),
  laughing: require('../image/icons/logs/laughing.png'),
  'leaving-the-fridge-open': require('../image/icons/logs/leaving-the-fridge-open.png'),
  'licking-lips': require('../image/icons/logs/licking-lips.png'),
  'liquid-soap': require('../image/icons/logs/liquid-soap.png'),
  'losing-focus': require('../image/icons/logs/losing-focus.png'),
  'memorize-poem-of-prose': require('../image/icons/logs/memorize-poem-of-prose.png'),
  'morning-prayer': require('../image/icons/logs/morning-prayer.png'),
  'muscle-strengthening': require('../image/icons/logs/muscle-strengthening.png'),
  netflix: require('../image/icons/logs/netflix.png'),
  'not-brushing-your-teeth': require('../image/icons/logs/not-brushing-your-teeth.png'),
  'not-doing-homework': require('../image/icons/logs/not-doing-homework.png'),
  'not-holding-eye-contact': require('../image/icons/logs/not-holding-eye-contact.png'),
  'not-proctecting-yourself-from-sun': require('../image/icons/logs/not-proctecting-yourself-from-sun.png'),
  'not-showering': require('../image/icons/logs/not-showering.png'),
  'online-surfing-in-class': require('../image/icons/logs/online-surfing-in-class.png'),
  overmedicating: require('../image/icons/logs/overmedicating.png'),
  overspending: require('../image/icons/logs/overspending.png'),
  'parking-car-at-right-place': require('../image/icons/logs/parking-car-at-right-place.png'),
  'practice-saying-no': require('../image/icons/logs/practice-saying-no.png'),
  quora: require('../image/icons/logs/quora.png'),
  reddit: require('../image/icons/logs/reddit.png'),
  'saying-yes-to-everyone': require('../image/icons/logs/saying-yes-to-everyone.png'),
  'sit-up': require('../image/icons/logs/sit-up.png'),
  'skipping-gym': require('../image/icons/logs/skipping-gym.png'),
  'skipping-meals': require('../image/icons/logs/skipping-meals.png'),
  'sleeping-with-makeup': require('../image/icons/logs/sleeping-with-makeup.png'),
  smile: require('../image/icons/logs/smile.png'),
  'smoking-cigarette': require('../image/icons/logs/smoking-cigarette.png'),
  snacking: require('../image/icons/logs/snacking.png'),
  spitting: require('../image/icons/logs/spitting.png'),
  stretch: require('../image/icons/logs/stretch.png'),
  'substitute-fruit-for-sugar': require('../image/icons/logs/substitute-fruit-for-sugar.png'),
  'substitute-unhealthy-with-healthy': require('../image/icons/logs/substitute-unhealthy-with-healthy.png'),
  twitter: require('../image/icons/logs/twitter.png'),
  'using-excessive-salt': require('../image/icons/logs/using-excessive-salt.png'),
  'watching-reality-television': require('../image/icons/logs/watching-reality-television.png'),
  'water-bottle-at-desk': require('../image/icons/logs/water-bottle-at-desk.png'),
  youtube: require('../image/icons/logs/youtube.png'),
  zumba: require('../image/icons/logs/zumba.png'),
  'video-games': require('../image/icons/logs/video-games.png'),
  'walk-everyday': require('../image/icons/logs/walk-everyday.png'),
  'chewing-tobacco': require('../image/icons/logs/chewing-tobacco.png'),
  smoking: require('../image/icons/logs/smoking.png'),
  drinking: require('../image/icons/logs/drinking-soda.png'),
  'reading-book': require('../image/icons/logs/reading-book.png'),
  communication: require('../image/icons/logs/communication.png'),
  medical: require('../image/icons/logs/medical.png'),
};
